import { observer } from 'mobx-react';
import * as React from 'react';
import { WrappedField } from '../../../core/forms';
import { Option } from '../../../core/options';

interface DefaultSelectProps<T extends string | number> {
    field: WrappedField<T> | WrappedField<T | undefined>;
    options: Option<T>[];
    label?: string;
    'data-role'?: string;
    className?: string;
    transparent?: boolean;
}

export const DefaultSelect = observer(function DefaultSelect<
    T extends string | number
>(props: DefaultSelectProps<T>) {
    const { className, field, options, label } = props;

    const hasNumberOptions = React.useCallback(
        () => options.some((option) => typeof option.value === 'number'),
        [options]
    );

    const onChange = (
        event: React.ChangeEvent<{
            name?: string | undefined;
            value: unknown;
        }>
    ) => {
        const value = event.currentTarget.value as string;
        if (hasNumberOptions()) {
            field.value = parseFloat(value) as T;
        } else {
            field.value = value as T;
        }
    };

    return (
        <dd className={classnames(className, 'field-group__member')}>
            <select
                required
                id="month"
                value={field.value ?? ''}
                onChange={onChange}
                data-role={props['data-role']}
            >
                {label && (
                    <option disabled value="">
                        {label}
                    </option>
                )}
                {options.map((opt) => (
                    <option value={opt.value} key={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </dd>
    );
});
